import { gql } from '@apollo/client';

export interface PendingPushBatchSummary {
    wmsBatchNumber: string | null;
    /** 推送状态：10=未推送, 15=部分推送, 20=已推送 */
    pushStatus: number | null;
    /** WMS 作业批次状态：0=未知 */
    wmsBatchStatus: number | null;
    pushableCount: number | null;
    sendHubName: string | null;
    planWhsArrivalTime: string | null;
    whsArrivalTime: string | null;
}

export interface PendingPushOrderSummary {
    newArrivalBatchCount: number | null;
    newArrivalPushableParcelCount: number | null;
    returnRedispatchParcelCount: number | null;
    batchList: PendingPushBatchSummary[] | null;
}

export const GET_PENDING_PUSH_ORDERS = gql`
    query QueryPendingPushOrders($warehouseId: Long!) {
        queryPendingPushOrders(warehouseId: $warehouseId) {
            newArrivalBatchCount
            newArrivalPushableParcelCount
            returnRedispatchParcelCount
            batchList {
                wmsBatchNumber
                pushStatus
                wmsBatchStatus
                pushableCount
                sendHubName
                planWhsArrivalTime
                whsArrivalTime
            }
        }
    }
`;

export interface GetPendingPushOrdersResponse {
    queryPendingPushOrders: PendingPushOrderSummary | null;
}

export interface GetPendingPushOrdersVariables {
    warehouseId: number;
}
